import React, {FC} from 'react';
import AppLoader from "../components/AppLoader/AppLoader";

const LoadingPage: FC = () => {
    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <AppLoader/>
        </div>
    );
};

export default LoadingPage;
